// extracted by mini-css-extract-plugin
export default {"body":"formInfoModal_body__dMttW","iconContainer":"formInfoModal_iconContainer__kKaBE","alert":"formInfoModal_alert__uIFct"};